import { MaterialModule } from '@app/material.module';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Component, inject, OnInit, OnDestroy} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TechnicianApiService } from '@services/api/user/technician/technician-api.service';
import { AuthService } from '@services/api/auth/auth.service';
import { Technician } from '@interfaces/technician';
import { Subject, takeUntil } from 'rxjs';
import { EmailComponent } from '@pages/users/technicians/email/email.component';
import { MatDialog } from '@angular/material/dialog';
import { ToastrServices } from '@services/toastr/toastr.service';
import { TablerIconsModule } from 'angular-tabler-icons';

@Component({
  selector: 'app-qrcode',
  imports: [MaterialModule, CommonModule, TranslateModule, TablerIconsModule],
  templateUrl: './qrcode.component.html',
  standalone: true,
  styleUrl: './qrcode.component.scss'
})
export class QrcodeComponent implements OnInit, OnDestroy{
  private technician_api_service = inject(TechnicianApiService);
  private auth_api_service = inject(AuthService);
  private toastr_service = inject(ToastrServices);
  private translate = inject(TranslateService);
  protected technician: Technician | null = null;
  protected qrcode: string = "";
  protected qrcode_formatted: string = "";
  // Diventa true quando la richiesta del QR e' finita: solo allora mostriamo "nessun QR"
  protected qrLoaded = false;
  private destroy$ = new Subject<void>();
  private dialog = inject(MatDialog);

  ngOnInit() {
    this.getUserData();
  }

  getUserData(): void {
    this.auth_api_service.get_user_data()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          this.technician = response.data;
          if (this.technician){
            this.getQrcode(this.technician);
          }
        },
        error: (error) => {
          console.error(error);
          this.qrLoaded = true;
        }
      });
  }

  getQrcode(technician: Technician): void {
    this.technician_api_service.get_qrcode(technician.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          this.qrcode = response.data.qrcode;
          this.qrLoaded = true;
        },
        error: (error) => {
          console.log(error);
          this.qrLoaded = true;
        }
      });
  }
  
  sendEmail(user: Technician | null): void{
    const dialogRef = this.dialog.open(EmailComponent, {
      data: {
        "technician_email": user?.email,
        "qr_code":this.qrcode
      },
      autoFocus: false,
      width: '560px',
      panelClass: 'xr-dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 'close' || !result) {
        //
      } else {
        if (result.success) {
          this.toastr_service.showSuccess(this.translate.instant('qrcode.send_success'), this.translate.instant('alert.success'));
        } else if (!result.success ) {
          this.toastr_service.showError(this.translate.instant('qrcode.send_error'), this.translate.instant('alert.error'));
        }
      }
    });
  }

  downloadQrcode() {
    if (this.qrcode) {
      const link = document.createElement('a');
      link.href = this.qrcode;
      link.download = `qrcode_${this.technician?.id || 'unknown'}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      console.warn('Nessun QR code disponibile per il download.');
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
